import React, { FC } from 'react';
import { ButtonGroup, Card, CardContent, CardHeader, ClickAwayListener, Grow, IconButton, MenuItem, MenuList, Paper, Popper, Typography } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { useStyles } from './styles';
import { DocumentIcon, HierarchyIcon } from '../../../../components';
import { PATH_CLIENTS_LIST, PATH_COMMISSIONS_BY_CLIENT, PATH_PARTNERS_HIERARCHY } from '../../../../utils';

interface Props {
  clients: string;
  translation: any;
}

export const Clients: FC<Props> = ({ clients, translation }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Card className={`${classes.root} ${classes.clients}`}>
        <CardHeader
          action={
            <>
              <ButtonGroup ref={anchorRef} className={classes.buttonGroup}>
                <IconButton className={classes.button} onClick={handleToggle}>
                  <MoreVert />
                </IconButton>
              </ButtonGroup>
              <Popper open={open} anchorEl={anchorRef.current} transition disablePortal style={{ zIndex: 6000 }}>
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList className={classes.menuList}>
                          <MenuItem className={classes.menuItemHierarchy} component={Link} to={PATH_PARTNERS_HIERARCHY}>
                            <HierarchyIcon />
                            <span className={classes.menuItemText}>{translation.text_6662}</span>
                          </MenuItem>
                          <span className={classes.menuTitle}>{translation.text_6663}</span>
                          <MenuItem className={classes.menuItem} component={Link} to={PATH_CLIENTS_LIST}>
                            <DocumentIcon />
                            <span className={classes.menuItemText}>{translation.text_809}</span>
                          </MenuItem>
                          <MenuItem className={classes.menuItem} component={Link} to={PATH_COMMISSIONS_BY_CLIENT}>
                            <DocumentIcon />
                            <span className={classes.menuItemText}>{translation.text_6657}</span>
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </>
          }
          title={translation.text_6279}
        />
        <CardContent>
          <Typography component="p" className={classes.content}>
            {clients}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};
